import React, { FunctionComponent } from "react";
import { IIconProps } from "./icon";

export const IdeaIcon: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;

  return (
    <svg viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Icons/Level/Gene-Big/Idea">
          <circle id="Oval" fill="#82BECC" cx="20" cy="20" r="20" />
          <line
            x1="21.8910714"
            y1="29.1304348"
            x2="19.4482143"
            y2="29.1304348"
            id="Path"
            stroke="#FFFFFF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <line
            x1="20.6696429"
            y1="10"
            x2="20.6696429"
            y2="11.7391304"
            id="Path"
            stroke="#FFFFFF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <line
            x1="11"
            y1="20.4347826"
            x2="13.0357143"
            y2="20.4347826"
            id="Path"
            stroke="#FFFFFF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <line
            x1="30"
            y1="20.4347826"
            x2="28.3035714"
            y2="20.4347826"
            id="Path"
            stroke="#FFFFFF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <line
            x1="12.1875"
            y1="12.6086957"
            x2="13.8839286"
            y2="14.3478261"
            id="Path"
            stroke="#FFFFFF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <line
            x1="29.1517857"
            y1="12.6086957"
            x2="27.4553571"
            y2="14.3478261"
            id="Path"
            stroke="#FFFFFF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M25.7589286,19.5652174 C25.6791566,16.718294 23.4466641,14.429606 20.6696429,14.3478261 C17.8926216,14.429606 15.6601291,16.718294 15.5803571,19.5652174 C15.6185254,21.3739495 16.5862075,23.0273498 18.125,23.9130435 L18.125,24.7826087 C18.125,25.2628563 18.5047585,25.6521739 18.9732143,25.6521739 L22.3660714,25.6521739 C22.8345272,25.6521739 23.2142857,25.2628563 23.2142857,24.7826087 L23.2142857,23.9130435 C24.7530782,23.0273498 25.7207603,21.3739495 25.7589286,19.5652174 L25.7589286,19.5652174 Z"
            id="Path"
            stroke="#FFFFFF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};
